import { useState } from 'react';

import Header from '@/components/Header';
import SidebarContent from '@/components/SidebarContent';
import { cn } from '@/lib/utils';

import OverlayProvider from './OverlayProvider';

const RootLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="flex flex-col min-h-screen bg-background pt-14">
      <Header
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        sidebarCollapsed={sidebarCollapsed}
        toggleSidebar={toggleSidebar}
      />

      <div className="flex grow">
        <aside
          className={cn(
            sidebarCollapsed ? 'w-16' : 'w-64',
            'hidden md:block transition-all duration-200 border-r bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60',
            'md:fixed md:bottom-0 md:top-14'
          )}
        >
          <SidebarContent
            setMobileMenuOpen={setMobileMenuOpen}
            sidebarCollapsed={sidebarCollapsed}
          />
        </aside>

        <main className={cn('flex-1 overflow-auto transition-all duration-200', sidebarCollapsed ? 'md:ml-16' : 'md:ml-64')}>
          <OverlayProvider>{children}</OverlayProvider>
        </main>
      </div>
    </div>
  );
};

export default RootLayout;
